// src/components/VisitTracker.tsx
"use client";

import { useEffect } from "react";

export default function VisitTracker() {
  useEffect(() => {
    fetch(`${process.env.NEXT_PUBLIC_API_URI}/api/v1/visit`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "x-api-key": process.env.NEXT_PUBLIC_API_KEY!,
      },
      credentials: "include",
    }).catch(() => {});
  }, []);

  return null;
}
